var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserUnfollow = function SvgUserUnfollow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16 7h-5v1h5zM6 1a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7m5 14H1v-2.5A3.5 3.5 0 0 1 4.5 9h3a3.5 3.5 0 0 1 3.5 3.5z",
    clipRule: "evenodd"
  })));
};
export default SvgUserUnfollow;